import IconAsMaskImage from '../IconAsMaskImage'

function Dice({ pureSvg, className, size, color, ...rest }) {
  const svg = (
    <svg {...rest} width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.263672" width="44" height="44" rx="10.56" fill="url(#paint0_radial_9230_6697)" />
      <path
        opacity="0.4"
        d="M12.8037 16.7191C12.8037 14.4105 14.6752 12.5391 16.9837 12.5391C19.2923 12.5391 21.1637 14.4105 21.1637 16.7191C21.1637 19.0276 19.2923 20.8991 16.9837 20.8991C14.6752 20.8991 12.8037 19.0276 12.8037 16.7191Z"
        fill="#585858"
      />
      <path
        d="M12.8037 27.2796C12.8037 24.971 14.6752 23.0996 16.9837 23.0996C19.2923 23.0996 21.1637 24.971 21.1637 27.2796C21.1637 29.5882 19.2923 31.4596 16.9837 31.4596C14.6752 31.4596 12.8037 29.5882 12.8037 27.2796Z"
        fill="#585858"
      />
      <path
        opacity="0.4"
        d="M23.3643 27.2796C23.3643 24.971 25.2357 23.0996 27.5443 23.0996C29.8528 23.0996 31.7243 24.971 31.7243 27.2796C31.7243 29.5882 29.8528 31.4596 27.5443 31.4596C25.2357 31.4596 23.3643 29.5882 23.3643 27.2796Z"
        fill="#585858"
      />
      <path
        d="M23.3643 16.7191C23.3643 14.4105 25.2357 12.5391 27.5443 12.5391C29.8528 12.5391 31.7243 14.4105 31.7243 16.7191C31.7243 19.0276 29.8528 20.8991 27.5443 20.8991C25.2357 20.8991 23.3643 19.0276 23.3643 16.7191Z"
        fill="#585858"
      />
      <defs>
        <radialGradient
          id="paint0_radial_9230_6697"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.2637 22) rotate(90) scale(22)"
        >
          <stop stopColor="#F3F3F3" />
          <stop offset="1" stopColor="#F2F2F2" />
        </radialGradient>
      </defs>
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className, size, color }} />
}

export default Dice
